import {
    Box,
    Card,
    CardContent,
    CardHeader,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
} from '@material-ui/core';
import React from 'react';
import { useStatisticsContext } from '../contexts/StatistiquesProvider';
import style from '../../../features/statistiques/css/Statistics.module.scss';
import classNames from 'classnames';

type Props = {};

const EffectifEnPortabilite: React.FC<Props> = () => {
    const { effectifEnPortabilite, isLoadingEffectifEnPortabilite } = useStatisticsContext();

    return (
        <>
            <Card className="w-100" style={{ boxShadow: 'none' }}>
                <CardHeader
                    title="Pourcentage de l'effectif global"
                    subheader={<Typography className={style.subheader}>En portabilité</Typography>}
                    className={style.graphsTitle}
                />
                <CardContent className={classNames(style.chartBox, 'verticalCentered')}>
                    <Box className={style.graphsDivider}></Box>
                    {!isLoadingEffectifEnPortabilite ? (
                        <>
                            <Box className="mt-2 pt-2 p-3 pl-5 pr-5 m-3">
                                <TableContainer component={Paper} className={style.tableNoBorder}>
                                    <Table className={style.tableEffectifsMoyens + ' mt-5'}>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell
                                                    className={classNames(
                                                        style.cellBlue,
                                                        style.cellBold,
                                                        style.bigger,
                                                        'text-center',
                                                    )}
                                                >
                                                    % de salariés en portabilité
                                                </TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            <TableRow>
                                                <TableCell className="text-center">
                                                    <Typography className={style.portabilite}>
                                                        {effectifEnPortabilite &&
                                                            (
                                                                effectifEnPortabilite[0].TX_salaries_en_portabilite *
                                                                100
                                                            ).toFixed(2)}
                                                        %
                                                    </Typography>
                                                </TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Box>
                        </>
                    ) : (
                        'Loading...'
                    )}
                </CardContent>
            </Card>
        </>
    );
};

export default EffectifEnPortabilite;
